import { listFromId } from 'utils/arrays';

function getLegs(route) {
  return listFromId(route.toJS(), 'legs');
}

export default getLegs;
